export const setClientInfo = data => ({
  type: 'SET_CLIENT_INFO',
  data,
});

export const updateClientInfo = data => ({  
  type: 'UPDATE_CLIENT_INFO',
  data,
});

export const clearClientInfo = () => ({
  type: 'CLEAR_CLIENT_INFO'
});
